import { CompensationType } from 'constants/loanApplication';

export const RADIO_GROUP_OPTIONS = [
  {
    value: CompensationType.BORROWER_PAID,
    label: 'Borrower Paid',
  },
  {
    value: CompensationType.LENDER_PAID,
    label: 'Lender Paid ',
  },
];
